// 新能源汽车案例API接口
import { http } from '@/utils/index'

// 获取新能源汽车案例详情
export const getNewEnergyCaseDetail = (id) => {
  return http.request("get", `/new-energy-case/detail/${id}`, {})
};

// 获取新能源汽车案例列表
export const getNewEnergyCaseList = () => {
  return http.request("get", "/new-energy-case/list", {})
};

// 获取相关新能源汽车案例推荐
export const getRelatedNewEnergyCases = (currentId) => {
  return http.request("get", `/new-energy-case/related/${currentId}`, {})
};
